import  React from 'react'
import ReactTable from 'react-table'
import { 
    Col, 
    Panel,  
    Row
} from 'react-bootstrap'
import { blue } from '../../../utils/constants'
import ContentWrapper from "../../../components/layout/ContentWrapper"
import { getUpcomingEvents }  from './api/getUpcomingEvents'

class UpcomingEvent extends React.Component {
    constructor(props)
    {
			super(props)
			this.state = {
				title: 'Upcoming Events',
				events:[]
			}
    }
    componentDidMount()
    {
			getUpcomingEvents('carlos').then(function(response){
        this.setState({ events:response.data })
			})
    }
    render()
    {
			const { events } = this.state

      return (  
       <ContentWrapper>
            <div className="content-heading">{this.state.title}</div>
						{
							((events.length == 0) && (
								<Panel>
									<Row>
										<div className="col-sm-6">
											<i style={{ color:blue }} className="fa fa-calendar" aria-hidden="true"/>
											&nbsp;&nbsp;You have no upcoming events
										</div>									
									</Row>
								</Panel>
							))
						}
            { 
							events.length > 0 &&  (<Panel className="col-sm-10">
                <Row>
                    <div className="col-sm-6"><i style={{ color:blue }} className="fa fa-calendar" aria-hidden="true" />&nbsp;&nbsp;This season events schedule</div>
                    <Col sm={12}>
                     <ReactTable
                        data={events}
                        columns={[
                        {
													Header: "Event Name",
													accessor: "Name"
                        },
                        {
													Header: "Location",
													accessor: "Name"
                        },
                        {
													Header: "Start Date",
													accessor: "startDate"
                        },                      
                        {
													Header: "End Date",
													accessor: "endDate"
												},
												{
													Header: "Contact Phone Number",
													accessor: "contactPhoneNumber"
												},
                        {
													Header: "Contact Email",
													accessor: "eventEmail"
                        }
                        ]}
                        defaultPageSize={5}
                        className="-striped -highlight"
                        />
                    </Col>
                </Row>
					</Panel>)
				}
        </ContentWrapper>
    )}
}

export default UpcomingEvent


// WEBPACK FOOTER //
// ./src/containers/event/upcomingevent/index.js